import Page from "../../components/Page";
import useFeaturePage from "./hooks/useFeaturePage";

const FeaturePage = () => {
  const page = useFeaturePage();
  return <Page {...page} />;
};

export default FeaturePage;
